<template>
  <el-tabs v-model="active_tab" :lazy="false" style="min-height: 400px">
    <el-tab-pane label="输入表单" name="tabForm">
        <frame-form v-if="parentData.is_component == false" ref="frameForm" :componentParam="parentData.form_code"></frame-form>

        <component
            v-if="parentData.is_component == true"
            min-height="200px"
            height="100%"
            width="100%"
            :is="getComponent(parentData.form_component)"
            style="border: 1px solid lightgray;overflow: auto"
        ></component>
    </el-tab-pane>

    <el-tab-pane label="流程图" name="tabImage">
      <FramePrcRender ref="prcRender" class="graph_container"></FramePrcRender>
    </el-tab-pane>
  </el-tabs>

</template>

<script>

import FramePrcRender from "./FramePrcRender";
import {defineAsyncComponent, markRaw} from "vue";

export default {
  name: "FrameProcessCreator",
  components: {FramePrcRender},
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      active_tab: 'tabForm'
    }
  },
  methods: {
    getComponent(component) {
      return markRaw(defineAsyncComponent(() => import('@/views/applications/' + component)));
    },
    showPrcImage() {
      var template = this.parentData.template
      if (template) {
        this.$refs.prcRender.render(JSON.parse(template.content));
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.showPrcImage();
    }, 500);

  }
}
</script>


<style lang="less" scoped>
@import '@/global.less';

.myContainer {
  padding: 5px;
}

.dirButtons {
  display: inline-flex;
}

.card-header {
  display: inline-flex;
  height: 36px;
}

.department-name {
  font-size: @fontSizeX;
}


.activeButton {
  background-color: #409EFF;
  color: #FFFFFF
}

.scroller::-webkit-scrollbar {
  width: 3px;
}

.scroller::-webkit-scrollbar-track {
  background-color: transparent;
}

.scroller::-webkit-scrollbar-thumb {
  background-color: #C1C1C1;
}

.departmentBody {
  border: #ececec solid 1px;
  font-weight: normal;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  padding: 0 1px 2px;
}

.departmentLeft {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  box-sizing: content-box;
}

.departmentRight {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: auto;
  width: 100%;
  min-width: 550px;
}

.LeftBody {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  padding-top: 10px;
  overflow-y: auto;
}

.flexRow {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.userRights {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 5px 5px 0 5px;
}

.departmentUserList {
  padding: 0 20px 10px;
  display: flex;
  flex-direction: column;
}


.titleFlex {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.departmentEdit {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 10px 0;
}

.departmentTable {
  border: none;
  width: 100%;
}

.flexRow > .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.buttonGroup {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.addButton {
  margin-left: 5px !important;
  padding: 9px;
}

.addDepartment {
  width: 140px;
  margin-right: 5px;
}

.LeftBody ::v-deep(.el-tree-node__expand-icon) {
  width: 15px;
}

.buttonGroup ::v-deep(.el-icon-key) {
  transform: rotate(180deg);
}

.editButton {
  color: lightgrey;
  min-height: 30px;
  padding: 0;
}

.editButton:hover {
  color: #00afff;
}
.el-tab-pane{
  height: 100%;
  overflow: auto;
}

</style>
